export default "__VITE_ASSET__DcyJ7Wq0__"